import { useState } from 'react';
import { copyGoalPeriods } from '../lib/goalActions';

export function GoalCopyButton({ periods, disabled = false, onCopied, label = 'Copy last period', className = 'btn sm goal-copy' }: {
  periods: ('month' | 'quarter')[]; disabled?: boolean; onCopied: () => void; label?: string; className?: string;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  return <>
    <button type="button" className={className} disabled={disabled || busy} title={disabled ? 'No previous targets to copy into this period' : undefined}
      onClick={async () => {
        setBusy(true); setError(false);
        try { await copyGoalPeriods(periods); onCopied(); }
        catch { setError(true); onCopied(); }
        finally { setBusy(false); }
      }}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden="true"><rect x="8" y="8" width="12" height="12" rx="2" /><path d="M16 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3" /></svg>{busy ? 'Copying…' : label}</button>
    {error && <span className="goal-action-error" role="alert">Could not copy targets. Try again.</span>}
  </>;
}
